import Loader from "../../assets/images/loader.gif"

function GifLoader() {
  return (
    <>
      <div style={{ height: "60vh", position: "relative" }}>
        <img style={{ position: "absolute", top: "20%" }} src={Loader} alt="Loading...." />
      </div>
      <div style={{ color: "white" }}>For a better experience, please download our app</div>
    </>
  )
}

export default GifLoader